import * as React from 'react';
import type {
  FiltersTemperatureControl,
  PaginationControl,
} from 'hooks/store/temperature-control/use-temperature-control-search-params';
import type { TTraceabilityEvent } from 'contracts/TraceabilityEvent';
import type { Pagination } from 'contracts/Pagination';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: FiltersTemperatureControl;
  pagination?: PaginationControl;
};

type Response = {
  data: TTraceabilityEvent[];
  meta: Pagination;
};

export const useFetchPaginatedTemperatureControl = () => {
  const fetchPaginatedTemperatureControl = React.useCallback(
    async (payload: Payload) => {
      const url = applyQueryString('/traceability-events', {
        ...payload.filters,
        ...payload.pagination,
      });

      try {
        const { data } = await api.get<Response>(url);
        return data;
      } catch (e) {
        throw handleApiError(e);
      }
    },
    []
  );

  return {
    fetchPaginatedTemperatureControl,
  };
};
